export function formHeader() {
  return { 'Content-Type': 'multipart/form-data' }
}
